export enum UsagePlanInterval {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}
